import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess } from "utils";

// POST subscriber/purchaseHistory — payload exactly as the portal sends it (dates yyyy-MM-dd)
export const purchaseHistoryList = createAsyncThunk('purchaseHistory/list', async ({ filter, navigate }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'subscriber/purchaseHistory',
            data: {
                "startDate": filter?.startDate,
                "endDate": filter?.endDate,
                "orderType": filter?.orderType || null,
                "paymentStatus": filter?.paymentStatus || null,
                "purchaseStatus": null,
                "custId": getCustId(),
                "custFlag": false,
                "partnerFlag": false,
                "partnerId": null,
                "pgId": null,
            },
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

// Order Type dropdown: GET subscriber/commonList/generic/purchaseHistoryCustomer
// -> dataList [{ text: "Repayment", value: "repayment" }, { text: "Plan", value: "plan" }]
export const orderTypeList = createAsyncThunk('purchaseHistory/orderType', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'subscriber/commonList/generic/purchaseHistoryCustomer',
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const purchaseHistory = createSlice({
    name: 'purchaseHistory',
    initialState: {
        list: [],
        orderType: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(purchaseHistoryList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(purchaseHistoryList.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.list = action.payload.data.dataList || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.list = []
            }
        });
        builder.addCase(purchaseHistoryList.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(orderTypeList.fulfilled, (state, action) => {
            if (isApiSuccess(action?.payload)) {
                state.orderType = action.payload.data.dataList || [];
            }
        });
    }
})

export default purchaseHistory.reducer;
